export default [
  "AATRA",
  "AATRAC",
  "ACA SALUD",
  "AERI",
  "AERI",
  "AJAMOP",
  "AJB ASOCIACION JUDICIAL BONAERENCE",
  "AMCI",
  "AMEBPBA",
  "AMEM",
  "AMFFA",
  "AMSTERDAM SALUD",
  "AMTYCA",
  "APL",
  "APOC",
  "APPI-OSTV",
  "APRES",
  "APSOT",
  "ASM SALUD",
  "ATE ASOCIACIÓN TRABAJADORES DEL ESTADO",
  "ATGGBA",
  "ATJ ASOCIACION DE LOS TESTIGOS DE JEHOVÁ",
  "BRISTOL MEDICINE",
  "CAJA DE ESCRIBANOS",
  "CAJA NOTARIAL",
  "CAPITANES Y BAQUEANOS FLUVIALES",
  "CASA SISTEMA ASISTENCIAL",
  "CENTRO MÉDICO PUEYRREDÓN",
  "COMEI",
  "CONEXIÓN SALUD",
  "CONFERENCIA EPISCOPAL ARGENTINA",
  "DAS, CONGRESO DE LA NACIÓN",
  "DASMI",
  "FATSA",
  "FEB",
  "FEDERADA SALUD",
  "GALENO",
  "HEALTH MEDICAL",
  "IOMA",
  "IOSFA",
  "JERARQUICOS SALUD",
  "LUIS PASTEUR",
  "MANDAR SALUD SA. (DAS CONGRESO)",
  "OBRA SOCIAL DE FUTBOLISTAS",
  "OBRA SOCIAL DE LA INDUSTRIA MADERERA",
  "OBRA SOCIAL DE MAQUINISTAS DE TEATRO Y TELEVISIÓN",
  "OBRA SOCIAL DEL PERSONAL DE BARRACAS DE LANAS, CERDAS, PINCELES, LAVADERO DE LANAS Y PEINADURIAS",
  "OBRA SOCIAL DEL PERSONAL DEL PAPEL CARTÓN Y QUIMICOS",
  "OBRAS SANITARIAS",
  "OMINT",
  "OPDEA",
  "OSAP",
  "OSAPM",
  "OSDEL",
  "OSDEPYM",
  "OSDOP",
  "OSECAC",
  "OSEMM",
  "OSFATLYF",
  "OSFATUN",
  "OSFE",
  "OSFFENTOS",
  "OSFOT",
  "OSIAD",
  "OSJERA",
  "OSMECON",
  "OSPACA",
  "OSPADEP",
  "OSPEA",
  "OSPEDYC",
  "OSPEGAP",
  "OSPEPBA",
  "OSPESA",
  "OSPESCA",
  "OSPIA",
  "OSPICA",
  "OSPIDA",
  "OSPIL",
  "OSPILM",
  "OSPLAD",
  "OSPOCE",
  "OSPPRA",
  "OSPRERA",
  "OSPSA",
  "OSPSIP",
  "OSPTV",
  "OSSEG",
  "OSSIMRA",
  "OSTEL",
  "OSTEP",
  "OSTRAC",
  "OSVARA",
  "PAMI",
  "PODER JUDICIAL",
  "POLICIA",
  "PREVENCION SALUD",
  "SADAIC",
  "SANCOR SALUD",
  "SCA",
  "SCIS SA",
  "SEPUBA",
  "SERVESALUD",
  "SIMECO",
  "SOEME",
  "SPB",
  "SPS",
  "SSP",
  "STMLa",
  "SUTEBA",
  "SUTHER OSPERYN",
  "SWISS MEDICAL",
  "U.DOC.P.BSAS",
  "UAI SALUD",
  "UNIMED",
  "UNIVERSIDAD SALUD",
  "UNLP",
  "UPCN (COSEGURO DE IOMA)",
  "VETERANOS DE GUERRA",
];



// WEBPACK FOOTER //
// ./src/components/Coberturas/Coverages.js